import { render, staticRenderFns } from "./stathistory.vue?vue&type=template&id=074f1c0a&"
import script from "./stathistory.vue?vue&type=script&lang=js&"
export * from "./stathistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports